import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DemandeEntretien from "./DemandeEntretien";
import { Tab, Tabs } from 'react-bootstrap';
import FavorisList from "./FavorisList";
import EditUser from "./EditUser";
import axios from "axios";
import moment from "moment";
import { NotificationManager } from "react-notifications";

export default function SingleUser() {
    const [tabKey, setTabKey] = useState('one');
    const [user, setUser] = useState(null);
    const [favo, setFavo] = useState([]);
    const [demande, setDemande] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        if (id) {
            axios.get(`users/${id}`).then(resp => {
                if (resp.status === 200) {
                    const { user, entretien, favo } = resp.data;
                    setUser(user);
                    setDemande(entretien);
                    setFavo(favo);
                }
            });
        }
    }, [id]);

    const handleToggleAccountStatus = (id, status) => {
        axios.put(`users/${id}`, { account: status }).then(resp => {
            if (resp.status === 200) {
                const message = status ? 'Utilisateur activé avec succès' : 'Utilisateur désactivé avec succès';
                NotificationManager.success(message, status ? 'Activation' : 'Désactivation', 4000);
                window.history.back();
            }
        });
    };

    if (!user) return <p>Chargement...</p>;

    const formattedDate = moment(user.created_at).fromNow();

    return (
        <div className="adminx-content">
            <div className="adminx-main-content">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="profile-card-4 z-depth-3">
                            <div className="card">
                                <div className="card-body text-center bg-primary rounded-top">
                                    <h5 className="mb-1 text-white">{user.name} {user.prenom}</h5>
                                    <h6 className="text-light">Société : {user.societe}</h6>
                                    <h6 className="text-light">ID : 00{user.id}</h6>
                                </div>
                                <div className="card-body">
                                    <ul className="list-group shadow-none">
                                        <ProfileDetail icon="bi bi-telephone-fill" label="Numéro mobile" value={user.phone} />
                                        <ProfileDetail icon="bi bi-envelope-at-fill" label="Adresse e-mail" value={<a href={`mailto:${user.email}`}>{user.email}</a>} />
                                        <ProfileDetail icon="bi bi-browser-chrome" label="Site Web" value={<Link to={`https://${user.site}`} target="_blank">{user.site}</Link>} />
                                        <ProfileDetail icon="bi bi-person-fill-gear" label="Post" value={user.post} />
                                        <ProfileDetail icon="bi bi-geo-alt-fill" label={user.adresse} value={user.pays} />
                                        <ProfileDetail icon="bi bi-person-circle" label="En tant que membre" value={formattedDate} />
                                        <ProfileDetail icon="bi bi-person-vcard-fill" label="Rôle de l'utilisateur" value={user.role} />

                                        <li className="list-group-item">
                                            <div className="list-icon">
                                                <i className={`bi ${user.account ? "bi-person-fill-check" : "bi-person-fill-x"}`}></i>
                                            </div>
                                            <div className="list-details">
                                                <button
                                                    onClick={() => handleToggleAccountStatus(user.id, !user.account)}
                                                    type="button"
                                                    className={`btn btn-sm ${user.account ? "btn-primary" : "btn-danger"}`}
                                                >
                                                    {user.account ? "Activer" : "Désactiver"} l' <span className="badge badge-light">utilisateur</span>
                                                </button>
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="row text-center mt-4">
                                        <ProfileStats label="Demande d'entretien" value={demande.length} />
                                        <ProfileStats label="Favoris" value={favo.length} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="card z-depth-3">
                            <div className="card-body">
                                <Tabs activeKey={tabKey} onSelect={setTabKey}>
                                    <Tab eventKey="one" title="Demande d'entretien">
                                        <DemandeEntretien ids={demande} />
                                    </Tab>
                                    <Tab eventKey="two" title="Liste des favoris">
                                        <FavorisList ids={favo} />
                                    </Tab>
                                    <Tab eventKey="three" title="Modifier l'utilisateur">
                                        <EditUser user={user} />
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function ProfileDetail({ icon, label, value }) {
    return (
        <li className="list-group-item">
            <div className="list-icon">
                <i className={icon}></i>
            </div>
            <div className="list-details">
                <span>{value}</span>
                <small>{label}</small>
            </div>
        </li>
    );
}

function ProfileStats({ label, value }) {
    return (
        <div className="col p-2">
            <h4 className="mb-1 line-height-5">{value}</h4>
            <small className="mb-0 font-weight-bold">{label}</small>
        </div>
    );
}
